// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-74267401] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.color-picker[data-v-74267401] {
  display: flex;
  overflow: hidden;
  align-content: flex-end;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box !important;
  width: 176px;
  padding: 8px;
  border-radius: 3px;
}
.color-picker--advanced-fields[data-v-74267401] {
  width: 264px;
}
.color-picker__simple[data-v-74267401] {
  display: grid;
  grid-template-columns: repeat(auto-fit, 44px);
  grid-auto-rows: 44px;
}
.color-picker__simple-color-circle[data-v-74267401] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-height: 34px;
  margin: auto;
  padding: 0;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, .25);
  border-radius: 50%;
  font-size: 16px;
}
.color-picker__simple-color-circle[data-v-74267401]:focus-within {
  outline: 2px solid var(--color-main-text);
}
.color-picker__simple-color-circle[data-v-74267401]:hover {
  opacity: .6;
}
.color-picker__simple-color-circle--active[data-v-74267401] {
  width: 38px;
  height: 38px;
  min-height: 38px;
  transition: all .1s ease-in-out;
  opacity: 1 !important;
}
.color-picker__advanced[data-v-74267401] {
  box-shadow: none !important;
}
.color-picker__navigation[data-v-74267401] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
[data-v-74267401] .vc-chrome {
  width: unset;
  background-color: var(--color-main-background);
}
[data-v-74267401] .vc-chrome-color-wrap {
  width: 30px;
  height: 30px;
}
[data-v-74267401] .vc-chrome-active-color {
  width: 34px;
  height: 34px;
  border-radius: 17px;
}
[data-v-74267401] .vc-chrome-body {
  padding: 14px 0 0;
  background-color: var(--color-main-background);
}
[data-v-74267401] .vc-chrome-body .vc-input__input {
  box-shadow: none;
}
[data-v-74267401] .vc-chrome-toggle-btn {
  filter: var(--background-invert-if-dark);
}
[data-v-74267401] .vc-chrome-saturation-wrap {
  border-radius: 3px;
}
[data-v-74267401] .vc-chrome-saturation-circle {
  width: 20px;
  height: 20px;
}
.slide-enter[data-v-74267401] {
  transform: translate(-50%);
  opacity: 0;
}
.slide-enter-to[data-v-74267401],
.slide-leave[data-v-74267401] {
  transform: translate(0);
  opacity: 1;
}
.slide-leave-to[data-v-74267401] {
  transform: translate(-50%);
  opacity: 0;
}
.slide-enter-active[data-v-74267401],
.slide-leave-active[data-v-74267401] {
  transition: all 50ms ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-a9d1ad5c.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;AACA;;EAEE,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;AACA;;EAEE,gCAAgC;AAClC","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-74267401] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.color-picker[data-v-74267401] {\n  display: flex;\n  overflow: hidden;\n  align-content: flex-end;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: content-box !important;\n  width: 176px;\n  padding: 8px;\n  border-radius: 3px;\n}\n.color-picker--advanced-fields[data-v-74267401] {\n  width: 264px;\n}\n.color-picker__simple[data-v-74267401] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 44px);\n  grid-auto-rows: 44px;\n}\n.color-picker__simple-color-circle[data-v-74267401] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  min-height: 34px;\n  margin: auto;\n  padding: 0;\n  color: #fff;\n  border: 1px solid rgba(0, 0, 0, .25);\n  border-radius: 50%;\n  font-size: 16px;\n}\n.color-picker__simple-color-circle[data-v-74267401]:focus-within {\n  outline: 2px solid var(--color-main-text);\n}\n.color-picker__simple-color-circle[data-v-74267401]:hover {\n  opacity: .6;\n}\n.color-picker__simple-color-circle--active[data-v-74267401] {\n  width: 38px;\n  height: 38px;\n  min-height: 38px;\n  transition: all .1s ease-in-out;\n  opacity: 1 !important;\n}\n.color-picker__advanced[data-v-74267401] {\n  box-shadow: none !important;\n}\n.color-picker__navigation[data-v-74267401] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n[data-v-74267401] .vc-chrome {\n  width: unset;\n  background-color: var(--color-main-background);\n}\n[data-v-74267401] .vc-chrome-color-wrap {\n  width: 30px;\n  height: 30px;\n}\n[data-v-74267401] .vc-chrome-active-color {\n  width: 34px;\n  height: 34px;\n  border-radius: 17px;\n}\n[data-v-74267401] .vc-chrome-body {\n  padding: 14px 0 0;\n  background-color: var(--color-main-background);\n}\n[data-v-74267401] .vc-chrome-body .vc-input__input {\n  box-shadow: none;\n}\n[data-v-74267401] .vc-chrome-toggle-btn {\n  filter: var(--background-invert-if-dark);\n}\n[data-v-74267401] .vc-chrome-saturation-wrap {\n  border-radius: 3px;\n}\n[data-v-74267401] .vc-chrome-saturation-circle {\n  width: 20px;\n  height: 20px;\n}\n.slide-enter[data-v-74267401] {\n  transform: translate(-50%);\n  opacity: 0;\n}\n.slide-enter-to[data-v-74267401],\n.slide-leave[data-v-74267401] {\n  transform: translate(0);\n  opacity: 1;\n}\n.slide-leave-to[data-v-74267401] {\n  transform: translate(-50%);\n  opacity: 0;\n}\n.slide-enter-active[data-v-74267401],\n.slide-leave-active[data-v-74267401] {\n  transition: all 50ms ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
